import { render, staticRenderFns } from "./FoodMenu.vue?vue&type=template&id=21c045bc"
import script from "./FoodMenu.vue?vue&type=script&lang=js"
export * from "./FoodMenu.vue?vue&type=script&lang=js"
import style0 from "./FoodMenu.vue?vue&type=style&index=0&id=21c045bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports